import { reduceWithIndex } from 'fp-ts/Record';
import { Ord } from 'fp-ts/string';
import { isEqual } from 'lodash/fp';

type Comparator<T> = (first: T, second: T) => boolean;

export function createUpdateValue<T>(originalValue: T, newValue: T, comparator: Comparator<T> = isEqual) {
    return comparator(originalValue, newValue) ? undefined : { value: newValue || null };
}

export const createBooleanUpdateValue = (originalValue: boolean | undefined, newValue: boolean | undefined) =>
    isEqual(originalValue, newValue) ? undefined : { value: newValue };

export const createUpdateValueObject = (originalObject: Record<string, unknown>, newObject: Record<string, unknown>) =>
    reduceWithIndex(Ord)({} as typeof newObject, (key, acc, value) => {
        const updateValue = createUpdateValue(originalObject[key], value);

        if (updateValue) acc[key] = updateValue;

        return acc;
    })(newObject);
